var link_preview_default = {
  "fontElementMap": "-gY9k",
  "linkPreview": "_2qlYc",
  "linkPreviewImage": "p-wvD",
  "linkPreviewInfo": "haGal",
  "linkPreviewTitle": "_1IID4",
  "ellipsis": "sgH9D",
  "linkPreviewDescription": "_5T3QQ",
  "linkPreviewUrl": "rlOdv"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
